import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { VioTablesModule } from 'vio-tables';
import { TABLE_CONFIG, TABLE_HEADER } from '../../../../node_modules/vio-tables/lib/Interfaces/commonInterfaces';
import { CommonFunctionService } from '../../services/common-function.service';
import { AddEditDeviceModalComponent } from '../add-edit-device-modal/add-edit-device-modal.component';
import { VioInputModule, VioInputService } from 'vio-input';
import { ApiRequestsService } from '../../services/api-requests.service';

@Component({
  selector: 'app-device-list',
  standalone: true,
  imports: [NgbModule, NgbDropdownModule, VioTablesModule, CommonModule, FormsModule, VioInputModule],
  templateUrl: './device-list.component.html',
  styleUrl: './device-list.component.scss'
})
export class DeviceListComponent implements OnInit {
  deviceListTableConfig: TABLE_CONFIG = {
    displayFormat: 'table',
    isSortable: true,
    isCheckBox: false,
    // "cellContextMenu": true,
    headerContextMenu: true,
    condition: false,
    displayBtnDiv: true,
    exporttoexcel: true,
    isButtonHover: true,
    formSearchBtnAt: 'start',
    cssClass: 'vio-table-bordered',

    headerContextMenuList: [
      {
        label: 'Hide Column',
        action: 'hidecolumn',
      },
      {
        label: 'Display Hidden Columns',
        action: 'displayhiddencols',
      },
      {
        label: 'Freeze Column(s)',
        action: 'freezecolumn',
      },
      {
        label: 'Unfreeze Column',
        action: 'unfreeze',
      },
      {
        label: 'Aggregate',
        action: 'aggregate',
      },
      {
        label: 'Remove Aggregate',
        action: 'removeaggregate',
      },
    ],
    actionButtons: [
      {
        btnName: 'Edit',
        btnTitle: 'Edit',
        btnIcon: 'fa fa-pen',
        btnClass: 'btn-primary mt-1',
      },
      {
        btnName: 'Delete',
        btnTitle: ' Delete',
        btnIcon: 'fa fa-trash',
        btnClass: 'btn-primary mt-1',
      }
    ],
  };

  deviceListTable: boolean = true;

  deviceListTableHeader: TABLE_HEADER[] = [
    { key: 'deviceId', display: 'Device Id', datatype: 'string' },
    { key: 'deviceDescr', display: 'Device Description', datatype: 'string' },
    { key: 'ctName', display: 'Configuration', datatype: 'string' },
    //{ key: 'colNameThree', display: 'Col Name Three', datatype: 'string' }
  ]

  deviceListTableData: any[] = [
  ];

  constructor(private ngbModal: NgbModal, public common: CommonFunctionService, private vioInputService: VioInputService, private apiRequest: ApiRequestsService) { }

  getDevicesList = async () => {
    let { errorCode, errorDescription, Data } = await this.apiRequest.postAPICallWithPromise('devices/getDevicesList')

    if (errorCode == this.apiRequest.NO_ERROR) {
      this.deviceListTableData = Data;
    }
  }

  ngOnInit(): void {
    this.common.pageTitle = 'Devices';
    this.getDevicesList();
  }

  buttonClickEvent = (event: any) => {
    console.log('Button click event = ', event)
    if (event.buttonName.btnName == 'Edit') {
      let paramsList = this.deviceListTableData.map(d => d.param)
      this.openDeviceModal({ deviceData: event.eventRow, params: paramsList })
    }
  }


  openDeviceModal = async (data: any) => {
    const ngbModelRef = this.ngbModal.open(AddEditDeviceModalComponent, {
      windowClass: 'add-edit-devices-modal',
      backdrop: 'static',
      //fullscreen: true,
      //size: 'xl',
      backdropClass: 'add-edit-devices-modal-backdrop',

    }); /****fullscreen: true, scrollable: true*/
    //ngbModelRef.componentInstance.isEdit= isedit;
    ngbModelRef.componentInstance.data = data;

    const result = await ngbModelRef.result;
    console.log('Result from modal', result);
    if (result == 'Yes') {
      this.getDevicesList();
    }
    // let { message } = result;
  };


}
